import React from "react";
import companyLogo1 from "../../assets/images/companyLogos/almg.webp";
import companyLogo2 from "../../assets/images/CompanyLogos/Ceylon Hospital.webp";
import companyLogo3 from "../../assets/images/CompanyLogos/chcare.webp";
import companyLogo4 from "../../assets/images/CompanyLogos/chwlogo.webp";
import companyLogo5 from "../../assets/images/CompanyLogos/chconnect.webp";
import companyLogo6 from "../../assets/images/CompanyLogos/yakkala.webp";
import companyLogo7 from "../../assets/images/CompanyLogos/siddha.webp";

interface Company {
  id: number;
  logo: string;
  mobile: { width: number; height: number };
  tablet: { width: number; height: number };
  desktop: { width: number; height: number };
}

const OurCompaniesSlider: React.FC = () => {
  const companies: Company[] = [
    {
      id: 1,
      logo: companyLogo1,
       mobile: { width: 60, height: 60 },
      tablet: { width: 80, height: 80 },
      desktop: { width: 100, height: 100 },
    },
    {
      id: 2,
      logo: companyLogo2,
        mobile: { width: 60, height: 60 },
      tablet: { width: 80, height: 80 },
      desktop: { width: 100, height: 100 },
    },
    {
      id: 3,
      logo: companyLogo3,
      mobile: { width: 60, height: 60 },
      tablet: { width: 80, height: 80 },
      desktop: { width: 100, height: 100 },
    },
    {
      id: 4,
      logo: companyLogo4,
      mobile: { width: 60, height: 60 },
      tablet: { width: 80, height: 80 },
      desktop: { width: 100, height: 100 },
    },
    {
      id: 5,
      logo: companyLogo5,
        mobile: { width: 60, height: 60 },
      tablet: { width: 80, height: 80 },
      desktop: { width: 100, height: 100 },
    },
    {
      id: 6,
      logo: companyLogo6,
  mobile: { width: 60, height: 60 },
      tablet: { width: 80, height: 80 },
      desktop: { width: 100, height: 100 },
    },
    {
      id: 7,
      logo: companyLogo7,
      mobile: { width: 60, height: 60 },
      tablet: { width: 80, height: 80 },
      desktop: { width: 100, height: 100 },
    },
  ];

  const duplicateArray = (arr: Company[], times: number): Company[] => {
    return Array(times).fill(arr).flat();
  };

  const duplicatedCompanies: Company[] = duplicateArray(companies, 5);

  return (
    <div className="slider-container_com mt-5 overflow-hidden">
      <div className="slider_com flex gap-2 sm:gap-3 md:gap-4 animate-slide-mobile sm:animate-slide-tablet lg:animate-slide-desktop py-3 md:py-4 lg:py-6">
        {duplicatedCompanies.map((company, index) => (
          <div
            className="slide hover:opacity-85 flex-shrink-0"
            key={`${company.id}-${index}`}
          >
            {/* Mobile size (default) */}
            <img
              src={company.logo}
              alt={`Company ${company.id}`}
              loading="lazy"
              width={company.mobile.width}
              height={company.mobile.height}
              className="shadow-md  rounded-lg object-contain sm:hidden"
              style={{
                aspectRatio: `${company.mobile.width}/${company.mobile.height}`,
              }}
            />

            {/* Tablet size */}
            <img
              src={company.logo}
              alt={`Company ${company.id}`}
              loading="lazy"
              width={company.tablet.width}
              height={company.tablet.height}
              className="shadow-md  rounded-lg object-contain hidden sm:block md:hidden"
              style={{
                aspectRatio: `${company.tablet.width}/${company.tablet.height}`,
              }}
            />

            {/* Desktop size */}
            <img
              src={company.logo}
              alt={`Company ${company.id}`}
              loading="lazy"
              width={company.desktop.width}
              height={company.desktop.height}
              className="shadow-md  rounded-lg object-contain hidden md:block "
              style={{
                aspectRatio: `${company.desktop.width}/${company.desktop.height}`,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurCompaniesSlider;

// import React from "react";
// import "../../styles/OurCompaniesSlider.css";
// import companyLogo1 from "../../assets/images/companyLogos/almg.webp";
// import companyLogo2 from "../../assets/images/CompanyLogos/Ceylon Hospital.webp";
// import companyLogo3 from "../../assets/images/CompanyLogos/chcare.webp";
// import companyLogo4 from "../../assets/images/CompanyLogos/chwlogo.webp";
// import companyLogo5 from "../../assets/images/CompanyLogos/chconnect.webp";
// import companyLogo6 from "../../assets/images/CompanyLogos/yakkala.webp";
// import companyLogo7 from "../../assets/images/CompanyLogos/siddha.webp";

// interface Company {
//   id: number;
//   logo: string;
// }

// const OurCompaniesSlider: React.FC = () => {
//   const companies: Company[] = [
//     { id: 1, logo: companyLogo1 },
//     { id: 2, logo: companyLogo2 },
//     { id: 3, logo: companyLogo3 },
//     { id: 4, logo: companyLogo4 },
//     { id: 5, logo: companyLogo5 },
//     { id: 6, logo: companyLogo6 },
//     { id: 7, logo: companyLogo7 },
//   ];

//   const duplicateArray = (arr: Company[], times: number): Company[] => {
//     return Array(times).fill(arr).flat();
//   };

//   const duplicatedCompanies: Company[] = duplicateArray(companies, 20);

//   return (
//     <div className="slider-container_com mt-5">
//       <div className="slider_com">
//         {duplicatedCompanies.map((company, index) => (
//           <div className="slide hover:opacity-85" key={index}>
//             <img src={company.logo} alt={`Company ${company.id}`} loading="lazy" className="shadow-md" />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default OurCompaniesSlider;
